import React from 'react';
import PropTypes from 'prop-types';

const ErrorText = ({ text }) => {
  return <span className="error-text">{text}</span>;
};

ErrorText.propTypes = {
  text: PropTypes.string,
};

export default ErrorText;
